import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCompensationWithHandler } from '../../../../../../global/ducks/benadmin-api';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { setNewHireEnrollmentMemberCompensation } from '../../slice/new-hire-enrollment-slices';

export function useMemberCompensation() {
    const dispatch = useDispatch();
    
    const memberCompensationLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberCompensationLoaded);

    const memberCurrentEmploymentId = useSelector<TcsmStates, number>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentId);
    const memberCurrentEmploymentIdLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentIdLoaded);
    const personGuid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);    

    useEffect(() => {
        if (memberCurrentEmploymentIdLoaded && memberCurrentEmploymentId  && !memberCompensationLoaded && personGuid) {            
            dispatch(getCompensationWithHandler(
                personGuid,
                memberCurrentEmploymentId,
                (response)=>{
                    const compensationData: any = response?.data;

                    if (compensationData?.compensations?.length > 0){
                        dispatch(setNewHireEnrollmentMemberCompensation(compensationData));    
                        return;
                    }

                    dispatch(setNewHireEnrollmentMemberCompensation(null));
                })); 
        }
    }, [memberCurrentEmploymentId, personGuid]);

    return memberCurrentEmploymentIdLoaded && memberCompensationLoaded;
}